import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar, Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";
import moment from "moment";

export default class List extends Component {

  static defaultProps = {
    title: 'Vyberte řidiče',
    defaultFilter: {}
  }

  constructor(props, context) {
    super(props);

    const rendererFiles = (val, row) => {
      const files = row.files.map(file => {
        const tooltip = <Tooltip id="file">{file.title}</Tooltip>
        return (
          <OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
            <a style={{color: '#000'}} href={'/file/download/' + file.id}>
              <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip"/>
            </a>
          </OverlayTrigger>
        )
      });
      return <div>
        {files}
      </div>
    };

    this.columnModel = [
      {
        name: 'edit',
        title: 'Akce',
        field: 'id',
        width: 80,
        sortable: false,
        renderer: (val, row) => {
          return (<div style={{color: '#2196F3', cursor: 'pointer'}} onClick={() => this.props.onAdd(row)}>
              <i className="fa fa-plus"></i> vybrat
            </div>
          );
        }
      },
      {
        name: 'surname',
        title: 'Příjmení',
        field: 'surname'
      },
      {
        name: 'name',
        title: 'Jméno',
        field: 'name'
      },
      {
        name: 'born',
        title: 'Dat. nar.',
        field: 'born',
        width: 90,
        renderer: Renderers.Date
      },
      {
        name: 'personal_number',
        title: 'Os. číslo',
        field: 'personal_number',
        width: 90,
      },
      {
        name: 'cTitle',
        title: 'Firma',
        field: 'cTitle',
      },
      {
        name: 'omv_expired',
        title: <span>Platnost&nbsp;do</span>,
        field: 'omv_expired',
        renderer: Renderers.Date
      },
      {
        name: 'op',
        title: 'Oprávnění',
        field: 'op',
        sortable: false,
        width: 150
      },
      /*{
        name: 'files',
        width: 58,
        sortable:false,
        renderer: rendererFiles
      }*/
    ];

    const filterSchema = {
      surname: {class: FilterInput},
      name: {class: FilterInput},
      personal_number: {class: FilterInput},
      omv_number: {class: FilterInput},
      cTitle: {class: FilterInput},
      rmv_number: {class: FilterInput},
      born: {class: DateRange},
      omv_expired: {class: DateRange, opens: 'left', ranges: {
          'Příští měsíc': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')],
          'Příští týden': [moment().add(1, 'week').startOf('isoweek'), moment().add(1, 'week').endOf('isoweek')],
          'Dnes': [moment(), moment()],
        }},
      fulltext: {class: SearchInput},
      edit: {
        class: FilterResetButton,
        visible: () => this.filter.isChanged(),
        onClick: () => this.filter.reset()
      }
    };
    this.filter = new FormManager(filterSchema);
    const sessionState = store.session.get('dg-driverpopup');
    this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'name', 'direction': 'asc'};
  }

  componentDidMount() {
    this.changeListener = () => {
      this.refs.datagrid.getWrappedInstance().refresh();
    };
    EventEmitter.on('driver.change', this.changeListener);
  }

  componentWillUnmount() {
    EventEmitter.removeListener('driver.change', this.changeListener);
  }

  render() {
    return (
      <Datagrid
        ref="datagrid"
        api="driver.getList"
        buttons={<h5>{this.props.title}</h5>}
        filters={['fulltext']}
        filter={this.filter}
        saveState={false}
        getRowClassName={null}
        defaultFilter={{cTitle: this.props.firm, ...this.props.defaultFilter}}
        fixedFilter={this.props.defaultFixedFilter}
        forceFilter={true}
        columnModel={this.columnModel}
        defaultSort={this.defaultSort}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Driver/PickerList.js